import React from 'react';

import { useAnimatedNumber } from '@lyearn/core/hooks/useAnimatedNumber';
import { getFormattedPercentage } from '@lyearn/core/utils/number/getFormattedPercentage';
import { useTranslation } from '@lyearn/i18n';
import { CircularProgress, Stack, StatusPill } from '@lyearn/ui';
import { StatusPillSize } from '@lyearn/ui/dist/esm/Pill/StatusPill/types';

function GeneratingStatusLabel({
  size,
  jobProgress,
}: {
  size?: StatusPillSize;
  /** 0 to 100 */
  jobProgress?: number;
}) {
  const { t } = useTranslation('Admin');
  const animatedJobProgress = useAnimatedNumber(jobProgress ?? 0, {
    duration: 60,
    type: 'integer',
  });

  const label = (
    <Stack alignItems="center" direction="row" gap={6}>
      <CircularProgress color="success" size="x-small" value={animatedJobProgress} />
      {t('Admin:PercentGenerated', { percent: getFormattedPercentage(animatedJobProgress) })}
    </Stack>
  );

  return <StatusPill appearance="secondary" label={label} size={size} variant="light" />;
}

export default React.memo(GeneratingStatusLabel);
